<CheckboxIcon :checked="modelValue" @click="toggle" :size="size"></CheckboxIcon>